/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import NewTeamMember from '../components/Teams/newTeamMember';
import TeamDetailCard from '../components/Teams/teamDetailCard';
import OrganizationCard from '../components/Organizations/organizationCard';
import TaskDetail from '../components/Tasks/taskDetail';
import ResultDetail from '../components/WorkPackage/resultDetail';
import FeatureDetail from '../components/Features/detailCard';
import CapabilityDetail from '../components/Capabilities/capabilityDetail';
import EpicDetail from '../components/Epics/epicDetail';
import ProductDetail from '../components/Products/productDetail';
import CadenceDetail from '../components/Cadences/cadenceDetail';
import TargetDetail from '../components/Targets/detailCard';
import NewDeployment from '../components/Deployments/newDeployment';
import DeploymentDetail from '../components/Deployments/detailCard';
import Message from '../components/Common/message';
import UnfinishedResults from '../components/Common/unfinishedResults';
import UnfinishedChildren from '../components/Common/unfinishedChildren';
import CadenceBurndown from '../components/Graph/cadenceBurndown';
import User from '../components/Users/user';
import WrapCard from '../components/Common/wrapCard';
import SmallNewModal from '../components/Common/smallNewModal';
import OrphanChildrenModal from '../components/Common/orphanChildrenModal';

const modalTypes = {
  newUser: { name: 'NEW_USER', component: User },
  editUser: { name: 'EDIT_USER', component: User },
  team: { name: 'TEAM', component: TeamDetailCard },
  smallNew: { name: 'SMALL_NEW', component: SmallNewModal },
  organizationCard: { name: 'ORGANIZATION_CARD', component: OrganizationCard },
  newTeamMember: { name: 'NEW_TEAM_MEMBER', component: NewTeamMember },
  newTask: { name: 'NEW_TASK', component: TaskDetail },
  taskDetail: { name: 'TASK_DETAIL', component: TaskDetail },
  newResult: { name: 'NEW_RESULT', component: ResultDetail },
  newFeature: { name: 'NEW_FEATURE', component: FeatureDetail },
  newCapability: { name: 'NEW_CABAPILITY', component: CapabilityDetail },
  newEpic: { name: 'NEW_EPIC', component: EpicDetail },
  newProduct: { name: 'NEW_PRODUCT', component: ProductDetail },
  productDetail: { name: 'PRODUCT_DETAIL', component: ProductDetail },
  resultDetail: { name: 'RESULT_DETAIL', component: ResultDetail },
  featureDetail: { name: 'FEATURE_DETAIL', component: FeatureDetail },
  capabilityDetail: { name: 'CAPABILITY_DETAIL', component: CapabilityDetail },
  epicDetail: { name: 'EPIC_DETAIL', component: EpicDetail },
  cadenceDetail: { name: 'CADENCE_DETAIL', component: CadenceDetail },
  targetDetail: { name: 'TARGET_DETAIL', component: TargetDetail },
  newDeployment: { name: 'NEW_DEPLOYMENT', component: NewDeployment },
  deploymentDetail: { name: 'DEPLOYMENT_DETAIL', component: DeploymentDetail },
  message: { name: 'MESSAGE', component: Message },
  user: { name: 'PROFILE', component: User },
  cadenceBurndown: { name: 'CADENCE_BURNDOWN', component: CadenceBurndown },
  unfinishedResults: {
    name: 'UNFINISHED_RESULTS',
    component: UnfinishedResults
  },
  unfinishedChildren: {
    name: 'UNFINISHED_CHILDREN',
    component: UnfinishedChildren
  },
  orphanChildren: {
    name: 'ORPHAN_CHILDREN',
    component: OrphanChildrenModal
  },
  wrapCard: { name: 'WRAP_CARD', component: WrapCard }
};

export const findModalType = (modalName) => {
  const type = Object.keys(modalTypes).find(
    (modalType) => modalTypes[modalType].name === modalName
  );
  return modalTypes[type];
};

export default modalTypes;
